import React, { useState, useRef } from 'react'
import close from '../../assets/images/close.svg'
import featured from "../../assets/images/featured.svg";
import down from "../../assets/images/down.svg";
import styles from './team.module.css';
import { uploadMedia } from '../../api/mediaApi';

const AddTeamMember = (props) => {
    const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const roleDropdownRef = useRef();
    const fileInputRef = useRef(null);

    const handleRoleSelect = (role) => {
        const roleValue = role?.role;
        props.handleChange({
            target: { name: "role", value: roleValue }
        });
        setIsRoleDropdownOpen(false);
    };

    const getRoleDisplayName = () => {
        if (!props?.formData?.role) return "Select Role";
        return props?.formData?.role;
    };

    const handleImageUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (e) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        setIsUploading(true);

        try {
            const file = files[0];
            const mediaIndex = Math.floor(Math.random() * (9999 - 1111 + 1)) + 1111;

            const uploadedMediaData = await uploadMedia(file, mediaIndex, '', false);

            props.handleChange({
                target: { name: "mediaId", value: uploadedMediaData }
            });
        } catch (error) {
            console.error('Upload failed:', error);
            props.handleChange({
                target: { name: "mediaId", value: null }
            });
        } finally {
            setIsUploading(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    return (
        <div>
            {props?.isNewTeamMember && (
                <>
                    <div className="popup-overlay">
                    </div>
                    <div className="popup-box add-new-user add-team-user" ref={props?.refrence}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={close} onClick={() => props?.setIsNewTeamMember(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>{props?.currentTeamMember ? "Edit Team Member" : "Add New Team Member"}</div>
                        <div className="popup-form">
                            <div className="form-group">
                                <label>Image</label>

                                <div className={`imageUploadBox`} disabled={isUploading}>
                                    <div id="newpageImageUpload" onClick={handleImageUploadClick} >
                                        <div className='image-upload-content'>
                                            <div className={`uploading-image ${isUploading ? 'loading' : ''}`}>
                                                <img
                                                    src={
                                                        props?.formData?.mediaId
                                                            ? props?.formData?.mediaId?.url || props?.formData?.media?.url
                                                            : featured
                                                    }
                                                    alt="FeaturedImage"
                                                />

                                                {isUploading && <div className="ringLoader loaderContinue"></div>}
                                            </div>

                                            <p >
                                                <span>{(props?.formData?.mediaId?.url || props?.formData?.media?.url) ? 'Replace' : 'Upload'}</span> <span>Media </span>
                                                <br />
                                                JPG, PNG (max. 128MB)
                                            </p>
                                        </div>
                                    </div>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        accept="image/*"
                                        hidden
                                        onChange={handleFileChange}
                                        disabled={isUploading}
                                    />
                                </div>

                                {props?.errorMessage?.mediaId && (
                                    <p className="error-message">{props?.errorMessage?.mediaId}</p>
                                )}
                            </div>

                            <div className="form-group" >
                                <label>Name</label>
                                <input
                                    className='form-input'
                                    name='name'
                                    value={props?.formData?.name}
                                    onChange={props?.handleChange}
                                    type='text'
                                    placeholder="Enter team member name"
                                />
                                {props?.errorMessage?.name && <p className='error-message'>{props?.errorMessage?.name}</p>}
                            </div>
                            <div className="form-group" >
                                <label>Email</label>
                                <input
                                    className='form-input'
                                    name='email'
                                    value={props?.formData?.email}
                                    onChange={props?.handleChange}
                                    type='email'
                                    placeholder="Enter email address"
                                />
                                {props?.errorMessage?.email && <p className='error-message'>{props?.errorMessage?.email}</p>}
                            </div>
                            <div className="form-group" >
                                <label>Password</label>
                                <input
                                    className='form-input'
                                    name='password'
                                    value={props?.formData?.password}
                                    onChange={props?.handleChange}
                                    type='password'
                                    placeholder="Enter password"
                                    autoComplete='new-password'
                                />
                                {props?.errorMessage?.password && <p className='error-message'>{props?.errorMessage?.password}</p>}
                            </div>
                            <div className="form-group role-dropdown-list">
                                <label>Role</label>
                                <div className='dropdown-wrapper' ref={roleDropdownRef}>
                                    <div className='dropdown-header' onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}>
                                        <span className={styles.title}>
                                            {getRoleDisplayName()}
                                        </span>
                                        <span className={`arrow ${isRoleDropdownOpen ? 'rotate' : ""}`}>
                                            <img src={down} alt="down" />
                                        </span>
                                    </div>

                                    {isRoleDropdownOpen && (
                                        <div className='dropdown-list'>
                                            {props?.roles?.map((role, index) => (
                                                <div
                                                    key={index}
                                                    className='dropdown-item'
                                                    onClick={() => handleRoleSelect(role)}
                                                >
                                                    <span>{role?.role}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                {props?.errorMessage?.role && <p className='error-message'>{props?.errorMessage?.role}</p>}
                            </div>
                            <div className="form-group" >
                                <label>Mobile Number</label>
                                <input
                                    className='form-input'
                                    name='mobileNumber'
                                    value={props?.formData?.mobileNumber}
                                    onChange={props?.handleChange}
                                    type='text'
                                    placeholder="Enter mobile number"
                                />
                                {props?.errorMessage?.mobileNumber && <p className='error-message'>{props?.errorMessage?.mobileNumber}</p>}
                            </div>

                            <div className="popup-actions">
                                <button className="cancel-btn" onClick={() => props?.setIsNewTeamMember(false)}>Cancel</button>
                                <button className="save-btn" onClick={props?.handleSubmit}>{props?.isLoading ? <div className='ringLoader'></div> : 'Save'}</button>
                            </div>

                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default AddTeamMember